import InfoOnline from "../../components/InfoOnline";
import NotPermissionComponent from "../../dashboard/NotPermissionComponent";
import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {useTaxPayerStorage} from "../../../services/storage/TaxPayerStorage";
import {useFindCurrentAdministrators} from "../../../services/apis/apiSuperintendence";
import CustomTable, {TypeItemTable} from "../../../components/general/CustomTable";
import IdentificationConsult from "../../terms-conditions/IdentificationConsult";
import {
    PaginationAdministratorsInterface
} from "../../../services/interface/query/superintendence/pagination-administrators-interface";
import {getMessageGeneric} from "../../../services/configuration/errorHandle";
import {formatDateString} from "../../../utils/daysOptions";
import {AdministratorsInterface} from "../../../services/interface/query/superintendence/administrators-interface";


export default function Current() {
    const { t } = useTranslation("global") as { t: (key: string) => string };

    const person = useTaxPayerStorage(data => data.data)

    const {
        mutate: findSuperintendence,
        data: successSuperintendence,
        error: errorSuperintendence,
        isPending: loadingSuperintendence,
    } = useFindCurrentAdministrators()

    const [response, setResponse] = useState<PaginationAdministratorsInterface | undefined>()
    const [listElement, setListElement] = useState<TypeItemTable[] | undefined>()
    const [index, setIndex] = useState<number | undefined>(0)

    useEffect(() => {
        if (
            (index || index === 0)
            && (person?.accountant || person?.taxIdentificationNumber)
        ) {
            findSuperintendence({
                identifier: person?.accountant ? person?.accountant : person?.taxIdentificationNumber, page: index,
                msj: t('current-administrators-detail')
            })
        }
    }, [person, index]);

    useEffect(() => {
        if (successSuperintendence) {
            setResponse(successSuperintendence)
        }
    }, [successSuperintendence]);

    useEffect(() => {
        if (response?.content && response.content.length > 0) {
            setListElement(response.content.map((item: AdministratorsInterface) => ({
                row: [
                    <IdentificationConsult
                        className={'text-header pl-1 font-light'}
                        identification={item.identification}
                    />,
                    item.names,
                    item.nationalityDescription,
                    item.position,
                    formatDateString(item.appointmentDate),
                    item.period,
                    // item.commercialRegistrationNumber,
                    formatDateString(item.commercialRegistryDate),
                    item.role,
                ]
            })))
        }
    }, [response]);

    return (
        <>
            <div className={'flex flex-row gap-2'}>
                <h3>{t('current-administrators-detail')}</h3>
                <InfoOnline onClick={() => {
                    if (
                        (index || index === 0)
                        && (person?.accountant || person?.taxIdentificationNumber)
                    ) {
                        findSuperintendence({
                            identifier: person?.accountant ? person?.accountant : person?.taxIdentificationNumber, page: index,
                            msj: t('current-administrators-detail')
                        })
                    }
                }}/>
            </div>
            <NotPermissionComponent
                className={'min-h-[50px]'}
                title={'/pj_information/administrators'}
                loading={loadingSuperintendence}
                error={errorSuperintendence}
                component={
                    <>
                        <CustomTable
                            pagination={true}
                            loading={loadingSuperintendence}
                            error={getMessageGeneric(errorSuperintendence, '/pj_information/administrators')}
                            header={[
                                t('identification'),
                                t('name'),
                                t('nationality'),
                                t('post'),
                                t('appointment-date'),
                                t('period'),
                                // t('commercial-registration-number'),
                                t('commercial-registration-date'),
                                t('rl-or-adm'),
                            ]}
                            number={response?.number}
                            totalElements={response?.totalElements}
                            totalPages={response?.totalPages}
                            {...{listElement, setIndex}}
                        />
                    </>
                }
            />
        </>
    )
}
